/* PickListSelectionComponent.js */

"use strict";
const MultipleSelectListControl = require("@gluenetworks/select_list").Multiple;
const Renderer = require("./PickListSelectionRenderer");

class PickListSelectionComponent extends MultipleSelectListControl {
    /**
     * @schema.name Pick List Selection
     * @schema.package @gluenetworks/picklist
     * @schema.packageIdentifier None
     * @schema.namespace
     * @schema.events ["Options", "Disabled", "Value", "Visible", "Invalid", "DarkTheme", "Focus", "Blur", "SetAttribute", "UserValue", "UserFocus", "UserBlur", "UserKeyDown"]
     *
     * @schema.configuration.options.example [{ label: 'Number 1', value: { valueProp1: 'blah1', valueProp2: { somethin: 'somethin1' } }, disabled: true },{ label: 'Number 2', value: { valueProp1: 'blah2', valueProp2: { somethin: 'somethin2' } } },{ label: 'Number 3', value: { valueProp1: 'blah3', valueProp2: { somethin: 'somethin3' } }, disabled: true },{ label: 'Number 4', value: { valueProp1: 'blah4', valueProp2: { somethin: 'somethin4' } } },{ label: 'Number 5', value: { valueProp1: 'blah5', valueProp2: { somethin: 'somethin5' } } }]
     *
     * @schema.configuration.value.example [{ valueProp1: 'blah1', valueProp2: { somethin: 'somethin1' } },{ valueProp1: 'blah2', valueProp2: { somethin: 'somethin2' } }]
     *
     */

    constructor(configOptions) {
        super(configOptions);
        this._renderer = new Renderer(this);

        this._registerListeners();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/

    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    /**
     * @schema.methods.setLastSelected.name setLastSelected
     * @schema.methods.setLastSelected.description Sets the last selected value and returns an instance of the control for chainability
     * @schema.methods.setLastSelected.returns Instance of the control
     * @schema.methods.setLastSelected.parameters.newVal.name newVal
     * @schema.methods.setLastSelected.parameters.newVal.description The new option text
     * @schema.methods.setLastSelected.parameters.newVal.type object
     */
    setLastSelected(newVal) {
        this._lastSelected = newVal;
        this.emit("LastSelected", this._lastSelected);
        return this;
    }

    /**
     * @schema.methods.setLastSelected.name setLastSelected
     * @schema.methods.setLastSelected.description Sets the last selected value and returns an instance of the control for chainability
     * @schema.methods.setLastSelected.returns Instance of the control
     * @schema.methods.setLastSelected.parameters.newVal.name newVal
     * @schema.methods.setLastSelected.parameters.newVal.description The new option text
     * @schema.methods.setLastSelected.parameters.newVal.type object
     */
    clearLastSelected() {
        this.setLastSelected(undefined);
        return this;
    }

    /**
     * @schema.methods.getLastSelected.name getLastSelected
     * @schema.methods.getLastSelected.description Returns the option label text
     * @schema.methods.getLastSelected.returns string
     */
    getLastSelected() {
        return this._lastSelected;
    }

    get lastSelected() {
        return this.getLastSelected();
    }

    set lastSelected(newVal) {
        return this.setLastSelected(newVal);
    }

    triggerValueAction() {
        this.emit("ValueAction", this.value);
    }
    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = PickListSelectionComponent;
